import { jsx as _jsx } from "react/jsx-runtime";
import { CatButton } from '@blocks-react/components/Button';
export const DealerLocatorCancelButton = ({ children, onCancel, isDisabled, }) => (_jsx(CatButton, { onClick: onCancel, type: "button", variant: "ghost", disabled: isDisabled, children: children }));
